<template>
  <div>
    <el-dialog
      :title="baseExchangeData.title"
      :visible.sync="baseExchangeData.show"
      center
      width="900px"
    >
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column
          type="index"
           :label="$t('SerialNumber')"
          width="50px"
        ></el-table-column>
        <el-table-column :label="$t('PlatformCurrency')" prop="PSymbol"></el-table-column>
        <el-table-column :label="$t('transactionCurrency')" prop="Symbol"></el-table-column>
        <el-table-column
          :label="$t('depositExchangeRaten')"
          prop="RechargeRateEx"
        ></el-table-column>
        <el-table-column
          :label="$t('TotalRebateAmountUT')"
          prop="WithwardRateEx"
        ></el-table-column>
        <el-table-column
         :label="$t('operator')"
          width="150px"
          prop="RateUpdateTime"
        ></el-table-column>
        <el-table-column
         :label="$t('OperatingTime')"
          width="150px"
          prop="RateUpdateAccount"
        ></el-table-column>
        <el-table-column  :label="$t('Actions')">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editRow(scope.row)"
              >{{ $t('modify') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="baseExchangeData.show = false"
          >{{$t('Confirm2')}}</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改 -->
    <editBase v-if="editData.show" :editData="editData" @saveData="saveData" />
  </div>
</template>

<script>
import editBase from "./editBase.vue";
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  components: { editBase },
  props: {
    baseExchangeData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [{}],
      loading: false,
      editData: {
        title: "修改基础汇率",
        show: false,
        data: {},
      },
    };
  },
  created() {
    this.getSymbolList();
  },
  methods: {
    getSymbolList() {
      const data = {
        SellerId: this.filters.SellerId,
        page: 1,
        pagesize: 1000,
      };
      this.loading = true;
      app.post("/pay/get_symbol_list", data, (res) => {
        if (res.code == 200) this.tableData = res.data.data;
        this.loading = false;
      });
    },
    editRow(row) {
      this.editData.show = true;
      this.editData.data = row;
    },
    saveData(val) {
      console.log(val);
      const data = {
        SellerId: this.editData.data.SellerId,
        Symbol: val.Symbol,
        RechargeRate: Number(val.RechargeRate),
        WithwardRate: Number(val.WithwardRate),
        GoogleCode: val.GoogleCode,
      };
      app.post("/pay/modify_symbol_rate", data, (res) => {
        if (res.code == 200) {
          this.editData.show = false;
          this.$message.success(this.$t('ModificationSuccessful'));
          this.getSymbolList();
        }
      });
    },
  },
};
</script>

<style scoped></style>
